module.exports = __webpack_public_path__ + "img/avatar.34808fec.svg";